import { TextField as MUITextField, Typography } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import FormHelperText from "@material-ui/core/FormHelperText";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import TableRow from "@material-ui/core/TableRow";
import { DatePicker } from "@material-ui/pickers";
import {
  DistrictField,
  ProvinceField,
  SubDistrictField,
  useAddress,
  ZipcodeField,
} from "components/request-document/components/Address";
import {
  Bagde,
  StyleCheckbox,
  StyledTableCell,
  useStyles,
} from "components/request-document/components/Commons";
import { getErrorMessage, isError } from "libs/utils/form";
import { get } from "lodash";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { selectMasterData } from "redux/modules/masterSlice";

const TextField = React.memo(MUITextField);

export default function PersonalIncome({ formik }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const canEdit = useSelector(canEditForm);
  const addressFieldOptions = useAddress({ formik });

  const masterData = useSelector(selectMasterData);
  const nationalityConfig = get(masterData, "nationalityConfig", []);
  const sourceIncoms = get(masterData, "sourcesOfincomeConfig", []);

  useEffect(() => {
    const n1 =
      formik.values.document.IncomeLastYear !== ""
        ? formik.values.document.IncomeLastYear
        : 0;
    const n2 =
      formik.values.document.IncomeLast2Year !== ""
        ? formik.values.document.IncomeLast2Year
        : 0;
    const sum = parseFloat(n1) + parseFloat(n2);
    formik.setFieldValue("document.IncomeTotalCurrent", sum);
  }, [
    formik.values.document.IncomeLastYear,
    formik.values.document.IncomeLast2Year,
  ]);

  return (
    <>
      <TableRow>
        <StyledTableCell colSpan={7}>
          <div className={classes.cellContent}>
            <div>
              <Typography>Average personal income per year </Typography>
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={4}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Year</InputLabel>
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Income (USD)</InputLabel>
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Last year (YYYY)</InputLabel>
              <DatePicker
                // style={{ width: 200 }}
                className={classes.formControl}
                inputVariant="outlined"
                disableFuture={false}
                openTo="year"
                format="YYYY"
                views={["year"]}
                name={`document.Lastyear`}
                value={get(formik.values, `document.Lastyear`, null) || null}
                onChange={(date) => {
                  formik.setFieldValue(
                    `document.Lastyear`,
                    date.format("YYYY")
                  );
                }}
                error={isError(`document.Lastyear`, formik)}
                helperText={getErrorMessage(`document.Lastyear`, formik)}
                disabled={!canEdit}
              />
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <TextField
                variant="outlined"
                className={classes.formControl}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                name="document.IncomeLastYear"
                type="number"
                value={formik.values.document.IncomeLastYear}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Last 2nd year (YYYY)</InputLabel>
              <DatePicker
                // style={{ width: 200 }}
                className={classes.formControl}
                inputVariant="outlined"
                disableFuture={false}
                openTo="year"
                format="YYYY"
                views={["year"]}
                name={`document.Last2Year`}
                value={get(formik.values, `document.Last2Year`, null) || null}
                onChange={(date) => {
                  formik.setFieldValue(
                    `document.Last2Year`,
                    date.format("YYYY")
                  );
                }}
                error={isError(`document.Last2Year`, formik)}
                helperText={getErrorMessage(`document.Last2Year`, formik)}
                disabled={!canEdit}
              />
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <TextField
                variant="outlined"
                className={classes.formControl}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                name="document.IncomeLast2Year"
                type="number"
                value={formik.values.document.IncomeLast2Year}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>
                Total current year income (as of the submission date)
              </InputLabel>
              <div style={{ display: "flex" }}>
                <DatePicker
                  // style={{ width: 200 }}
                  className={classes.formControl}
                  inputVariant="outlined"
                  disableFuture={false}
                  openTo="year"
                  format="DD-MM-YYYY"
                  label="Start"
                  views={["year", "month", "date"]}
                  name={`document.TotalCurrent`}
                  value={
                    get(formik.values, `document.TotalCurrent`, null) || null
                  }
                  onChange={(date) => {
                    formik.setFieldValue(
                      `document.TotalCurrent`,
                      date.format("YYYY-MM-DD")
                    );
                  }}
                  error={isError(`document.TotalCurrent`, formik)}
                  helperText={getErrorMessage(`document.TotalCurrent`, formik)}
                  disabled={!canEdit}
                />
                <DatePicker
                  // style={{ width: 200 }}
                  className={classes.formControl}
                  inputVariant="outlined"
                  disableFuture={false}
                  openTo="year"
                  format="DD-MM-YYYY"
                  label="End"
                  views={["year", "month", "date"]}
                  name={`document.TotalCurrentEnd`}
                  value={
                    get(formik.values, `document.TotalCurrentEnd`, null) || null
                  }
                  onChange={(date) => {
                    formik.setFieldValue(
                      `document.TotalCurrentEnd`,
                      date.format("YYYY-MM-DD")
                    );
                  }}
                  error={isError(`document.TotalCurrentEnd`, formik)}
                  helperText={getErrorMessage(
                    `document.TotalCurrentEnd`,
                    formik
                  )}
                  disabled={!canEdit}
                />
              </div>
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <TextField
                variant="outlined"
                className={classes.formControl}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                name="document.IncomeTotalCurrent"
                type="number"
                inputProps={{ readOnly: true }}
                value={formik.values.document.IncomeTotalCurrent}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={6}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Sources of income</InputLabel>
              <FormGroup row>
                {sourceIncoms.map((x) => (
                  <>
                    {x.sourcesOfincomeID !== "O" ? (
                      <FormControlLabel
                        control={
                          <StyleCheckbox
                            disabled={!canEdit}
                            name="document.sourcesOfincomeID"
                            checked={formik.values.document.sourcesOfincomeID
                              .split(",")
                              .some((xs) => xs === x.sourcesOfincomeID)}
                            onClick={() => {
                              const arr =
                                formik.values.document.sourcesOfincomeID.split(
                                  ","
                                );
                              const value = arr.find(
                                (xs) => xs === x.sourcesOfincomeID
                              )
                                ? arr.filter((xs) => xs !== x.sourcesOfincomeID)
                                : [...arr, x.sourcesOfincomeID];
                              formik.setFieldValue(
                                "document.sourcesOfincomeID",
                                value.join(",")
                              );
                            }}
                          />
                        }
                        label={x.sourcesOfincomeName}
                      />
                    ) : null}
                  </>
                ))}
              </FormGroup>
              {sourceIncoms.map((x) => (
                <>
                  {x.sourcesOfincomeID === "O" ? (
                    <>
                      <FormControlLabel
                        control={
                          <StyleCheckbox
                            disabled={!canEdit}
                            name="document.sourcesOfincomeID"
                            checked={
                              formik.values.document.sourcesOfincomeID
                                .split(",")
                                .some((xs) => xs === x.sourcesOfincomeID)
                              // formik.values.document.sourcesOfincomeID ===
                              // x.sourcesOfincomeID
                            }
                            onClick={() => {
                              const arr =
                                formik.values.document.sourcesOfincomeID.split(
                                  ","
                                );
                              const value = arr.find(
                                (xs) => xs === x.sourcesOfincomeID
                              )
                                ? arr.filter((xs) => xs !== x.sourcesOfincomeID)
                                : [...arr, x.sourcesOfincomeID];
                              formik.setFieldValue(
                                "document.sourcesOfincomeID",
                                value.join(",")
                              );
                            }}
                          />
                        }
                        label={x.sourcesOfincomeName}
                      />
                      <TextField
                        variant="outlined"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        name="document.sourcesOfincomeOther"
                        value={formik.values.document.sourcesOfincomeOther}
                      />
                    </>
                  ) : null}
                </>
              ))}
              <FormHelperText
                error={isError("document.sourcesOfincomeID", formik)}
              >
                {getErrorMessage("document.sourcesOfincomeID", formik)}
              </FormHelperText>
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
    </>
  );
}
